// The Planet Vertexia (Animation) System
// all geo, materials, and positioning handled here
// orbit paths too?
import * as THREE from "three"
import Experience from "../Experience"

//import OrbitPath from "./OrbitPath.js"

import CustomShaderMaterial from "three-custom-shader-material/vanilla"
import planetAnimationVertexShader from "../../shaders/planetAnimation/planetAnimationVertex.glsl"
import planetAnimationFragmentShader from "../../shaders/planetAnimation/planetAnimationFragment.glsl"

import moonAnimationModelingVertexShader from "../../shaders/moonAnimationModeling/moonAnimationModelingVertex.glsl"
import moonAnimationModelingFragmentShader from "../../shaders/moonAnimationModeling/moonAnimationModelingFragment.glsl"

//import moonAnimationRiggingVertexShader from "../../shaders/moonAnimationRigging/moonAnimationRiggingVertex.glsl"
//import moonAnimationRiggingFragmentShader from "../../shaders/moonAnimationRigging/moonAnimationRiggingFragment.glsl"

import { mergeVertices } from "three/examples/jsm/utils/BufferGeometryUtils.js"


// Planet Animation
export class PlanetAnimation{
    constructor(){
        this.experience = new Experience()
        this.time = this.experience.time
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        //this.orbitPath = new OrbitPath()
        this.orbitPathFile = this.resources.items.orbitModel
        this.orbitPath = this.orbitPathFile.children[0]
        this.orbits = []
        this.planetGroup = new THREE.Group()
        this.moonAOrbitDistance = 8
        this.moonBOrbitDistance = 15
        this.moonCOrbitDistance = 22
        this.moonDOrbitDistance = 27
        
        // Subscribe to the tick function
        this.time.addEventListener("tick", ()=>{
            this.rotate()
            this.orbit()
        })

        //console.log("Planet Animation")
        
        this.setGeometry()
        this.setTextures()
        this.setMaterials()
        this.setMesh()
        this.setPosition()
        this.setOrbitPaths()
    }

    setGeometry(){
        let animationPlanetGeo = new THREE.IcosahedronGeometry(5, 40)
        this.geometry = mergeVertices(animationPlanetGeo)
        this.geometry.computeTangents()
    }
    setTextures(){
        
    }

    setMaterials(){
        this.lineMat = new THREE.LineBasicMaterial({
            color: 0x555555,
            linewidth:1
        })

        this.colors = {}
        // this.colors.colorA = '#14532d'
        // this.colors.colorB = '#9ae62d'
        this.colors.colorA = '#404436'
        this.colors.colorB = '#91aa5f'
        this.colors.roughnessLow = '0.1'
        this.colors.roughnessHigh = '0.9'

        this.uniforms = {}
        this.uniforms.uPositionFrequency = new THREE.Uniform(0.4),
        this.uniforms.uStrength = new THREE.Uniform(0.1),
        this.uniforms.uColorLow = new THREE.Uniform(new THREE.Color(this.colors.colorA)),
        this.uniforms.uColorHigh = new THREE.Uniform(new THREE.Color(this.colors.colorB))
        
        this.material = new CustomShaderMaterial({
            // CustomShaderMaterial
            baseMaterial: THREE.MeshPhysicalMaterial,
            //baseMaterial: THREE.MeshStandardMaterial,
            vertexShader: planetAnimationVertexShader,
            fragmentShader: planetAnimationFragmentShader,
            uniforms: this.uniforms,
            silent: true,
            
            //MeshPhysicalMaterial
            metalness: 0.0,
            roughness: 0.0,
            color: 0xffffff,
            emissive: 0x111111,
            transmission: 0.0,
            ior: 1.5,
            thickness: 1.5,
            transparent: false,
            wireframe: false,
            depthWrite: true,
            depthTest: true,
        })
    }

    setMesh(){
        this.mesh = new THREE.Mesh(
            this.geometry,
            this.material
        )
        this.mesh.castShadow = true
        this.mesh.receiveShadow = true
        this.mesh.rotation.order = "ZYX"
        this.mesh.rotation.z = 20 * (Math.PI / 180)
        this.scene.add(this.mesh)
    }

    setPosition(){
        // Set the Parent Planet Parameters
        this.planetTilt = 20 * (Math.PI / 180)
        this.orbitDistance = 100
        this.orbitSpeed = 0.0
        this.offset = Math.PI * 0.02
        this.planetGroup.position.x = this.orbitDistance * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset)
        this.planetGroup.position.z = this.orbitDistance * Math.cos(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset)
        this.scene.add(this.planetGroup)
    }

    setOrbitPaths(){

        this.orbitPath.material = this.lineMat
        // duplicates and places nurbs geo for orbit representation
        let tempPlanetPath
        let tempMoonAPath
        let tempMoonBPath
        let tempMoonCPath
        let tempMoonDPath
        
        for(let i = 0; i < 5; i ++){
            const childClone = this.orbitPath.clone()
            this.scene.add(childClone)
            this.orbits.push(childClone)
        }
        [
            tempPlanetPath,
            tempMoonAPath,
            tempMoonBPath,
            tempMoonCPath,
            tempMoonDPath
        ] = this.orbits

        // Set orbit transforms
        this.planetPath = tempPlanetPath
        this.planetPath.scale.set(this.orbitDistance, this.orbitDistance, this.orbitDistance)

        this.moonAPath = tempMoonAPath
        this.moonAPath.scale.set(this.moonAOrbitDistance, this.moonAOrbitDistance, this.moonAOrbitDistance)
        this.moonAPath.rotation.set(0,0,this.planetTilt)

        this.moonBPath = tempMoonBPath
        this.moonBPath.scale.set(this.moonBOrbitDistance, this.moonBOrbitDistance, this.moonBOrbitDistance)
        this.moonBPath.rotation.set(0,0,this.planetTilt)

        this.moonCPath = tempMoonCPath
        this.moonCPath.scale.set(this.moonCOrbitDistance, this.moonCOrbitDistance, this.moonCOrbitDistance)
        this.moonCPath.rotation.set(0,0,this.planetTilt)

        this.moonDPath = tempMoonDPath
        this.moonDPath.scale.set(this.moonDOrbitDistance, this.moonDOrbitDistance, this.moonDOrbitDistance)
        this.moonDPath.rotation.set(0,0,this.planetTilt)

    }

    rotate(){
        this.mesh.rotation.y = (this.time.elapsed * 0.001) * 0.05
    }

    orbit(){
        if(this.planetGroup){
            this.mesh.position.x = this.planetGroup.position.x
            this.mesh.position.z = this.planetGroup.position.z
        }

        if(this.moonAPath){
            this.moonAPath.position.x = this.planetGroup.position.x
            this.moonAPath.position.z = this.planetGroup.position.z
        }

        if(this.moonBPath){
            this.moonBPath.position.x = this.planetGroup.position.x
            this.moonBPath.position.z = this.planetGroup.position.z
        }

        if(this.moonCPath){
            this.moonCPath.position.x = this.planetGroup.position.x
            this.moonCPath.position.z = this.planetGroup.position.z
        }

        if(this.moonDPath){
            this.moonDPath.position.x = this.planetGroup.position.x
            this.moonDPath.position.z = this.planetGroup.position.z
        }
    }
}

export class MoonAnimationModeling{
    constructor(parentPlanet){
        this.experience = new Experience()
        this.time = this.experience.time
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.parentPlanet = parentPlanet
        this.planetGroup = this.parentPlanet.planetGroup
        this.planetTilt = this.parentPlanet.planetTilt
        this.orbitDistance = this.parentPlanet.moonAOrbitDistance
        
        // Subscribe to the tick function
        this.time.addEventListener("tick", ()=>{
            this.rotate()
            this.orbit()
        })

        this.setGeometry()
        this.setTextures()
        this.setMaterials()
        this.setMesh()
        this.setPosition()
    }

    setGeometry(){
        let moonAnimationModelingGeo = new THREE.IcosahedronGeometry(0.5, 25) // 0.5, 50
        this.geometry = mergeVertices(moonAnimationModelingGeo)
        this.geometry.computeTangents()
    }
    setTextures(){
        
    }

    setMaterials(){
        this.colors = {}
        this.colors.colorA = '#a79c86'
        this.colors.colorB = '#d2cfda'
        this.colors.roughnessLow = '0.1'
        this.colors.roughnessHigh = '0.9'

        this.uniforms = {}
        this.uniforms.uPositionFrequency = new THREE.Uniform(3.4),
        this.uniforms.uStrength = new THREE.Uniform(0.01),
        this.uniforms.uColorLow = new THREE.Uniform(new THREE.Color(this.colors.colorA)),
        this.uniforms.uColorHigh = new THREE.Uniform(new THREE.Color(this.colors.colorB))
        
        this.material = new CustomShaderMaterial({
            // CustomShaderMaterial
            baseMaterial: THREE.MeshPhysicalMaterial,
            vertexShader: moonAnimationModelingVertexShader,
            fragmentShader: moonAnimationModelingFragmentShader,
            uniforms: this.uniforms,
            silent: true,
            
            //MeshPhysicalMaterial
            metalness: 0.0,
            roughness: 1.0,
            color: 0xffffff,
            emissive: 0x000000,
            transmission: 0,
            ior: 1.5,
            thickness: 1.5,
            transparent: false,
            wireframe: false,
            depthWrite: true,
            depthTest: true,
        })
    }

    setMesh(){
        this.mesh = new THREE.Mesh(
            this.geometry,
            this.material
        )
        this.mesh.castShadow = true
        this.mesh.receiveShadow = true
        this.mesh.rotation.order = "ZYX"
        this.mesh.rotation.z = this.planetTilt
        this.scene.add(this.mesh)
    }
    
    setPosition(){
        this.orbitPlane = (Math.sin(this.planetTilt) * this.orbitDistance) / (Math.tan(this.planetTilt))
        this.orbitSpeed = 0.1
        this.offset = Math.PI * 1.5
    }
    
    rotate(){
        this.mesh.rotation.y = (this.time.elapsed * 0.001) * 0.6
    }

    orbit(){
        if(this.planetGroup){
            this.mesh.position.x = this.planetGroup.position.x + (this.orbitPlane * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
            this.mesh.position.z = this.planetGroup.position.z + (this.orbitDistance * Math.cos(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
            this.mesh.position.y = this.planetGroup.position.y + (this.orbitDistance * Math.sin(this.planetTilt) * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
        }
        else{
            console.log("no Planet Group")
        }
    }
}

export class MoonAnimationRigging{
    constructor(parentPlanet){
        this.experience = new Experience()
        this.time = this.experience.time
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.parentPlanet = parentPlanet
        this.planetGroup = this.parentPlanet.planetGroup
        this.planetTilt = this.parentPlanet.planetTilt
        this.orbitDistance = this.parentPlanet.moonBOrbitDistance
        
        // Subscribe to the tick function
        this.time.addEventListener("tick", ()=>{
            this.rotate()
            this.orbit()
        })

        this.setGeometry()
        this.setTextures()
        this.setMaterials()
        this.setMesh()
        this.setPosition()
    }

    setGeometry(){
        let moonAnimationRiggingGeo = new THREE.IcosahedronGeometry(0.7, 25)
        this.geometry = mergeVertices(moonAnimationRiggingGeo)
        this.geometry.computeTangents()
    }
    setTextures(){
        
    }

    setMaterials(){
        this.colors = {}
        // this.colors.colorA = '#9812fe'
        // this.colors.colorB = '#bb1ad0'
        this.colors.colorA = '#3e66f9'
        //this.colors.colorB = '#6081ff'
        this.colors.colorB = '#89f3ff'
        this.colors.roughnessLow = '0.1'
        this.colors.roughnessHigh = '0.1'

        this.uniforms = {}
        this.uniforms.uPositionFrequency = new THREE.Uniform(0.9),
        this.uniforms.uStrength = new THREE.Uniform(0.2),
        this.uniforms.uColorLow = new THREE.Uniform(new THREE.Color(this.colors.colorA)),
        this.uniforms.uColorHigh = new THREE.Uniform(new THREE.Color(this.colors.colorB))
        
        this.material = new CustomShaderMaterial({
            // CustomShaderMaterial
            baseMaterial: THREE.MeshPhysicalMaterial,
            // vertexShader: moonAnimationRiggingVertexShader,
            // fragmentShader: moonAnimationRiggingFragmentShader,
            vertexShader: moonAnimationModelingVertexShader,
            fragmentShader: moonAnimationModelingFragmentShader,
            uniforms: this.uniforms,
            silent: true,
            
            //MeshPhysicalMaterial
            metalness: 0.0,
            roughness: 0.5,
            color: 0xffffff,
            emissive: 0x000000,
            transmission: 0.0,
            ior: 1.5,
            thickness: 1.5,
            transparent: false,
            wireframe: false,
            depthWrite: true,
            depthTest: true,
        })
    }

    setMesh(){
        this.mesh = new THREE.Mesh(
            this.geometry,
            this.material
        )
        this.mesh.castShadow = true
        this.mesh.receiveShadow = true
        this.mesh.rotation.order = "ZYX"
        this.mesh.rotation.z = this.planetTilt
        this.scene.add(this.mesh)
    }
    
    setPosition(){
        this.orbitPlane = (Math.sin(this.planetTilt) * this.orbitDistance) / (Math.tan(this.planetTilt))
        this.orbitSpeed = 0.09
        this.offset = Math.PI * 1.25
    }
    
    rotate(){
        this.mesh.rotation.y = (this.time.elapsed * 0.001) * 0.8
    }

    orbit(){
        if(this.planetGroup){
            this.mesh.position.x = this.planetGroup.position.x + (this.orbitPlane * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
            this.mesh.position.z = this.planetGroup.position.z + (this.orbitDistance * Math.cos(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
            this.mesh.position.y = this.planetGroup.position.y + (this.orbitDistance * Math.sin(this.planetTilt) * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
        }
        else{
            console.log("no Planet Group")
        }
    }
}

export class MoonAnimationAnimation{
    constructor(parentPlanet){
        this.experience = new Experience()
        this.time = this.experience.time
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.parentPlanet = parentPlanet
        this.planetGroup = this.parentPlanet.planetGroup
        this.planetTilt = this.parentPlanet.planetTilt
        this.orbitDistance = this.parentPlanet.moonCOrbitDistance
        
        // Subscribe to the tick function
        this.time.addEventListener("tick", ()=>{
            this.rotate()
            this.orbit()
        })

        this.setGeometry()
        this.setTextures()
        this.setMaterials()
        this.setMesh()
        this.setPosition()
    }

    setGeometry(){
        let moonAnimationAnimationGeo = new THREE.IcosahedronGeometry(1, 25)
        this.geometry = mergeVertices(moonAnimationAnimationGeo)
        this.geometry.computeTangents()
    }
    setTextures(){
        
    }

    setMaterials(){
        this.colors = {}
        this.colors.colorA = '#e27b58'
        this.colors.colorB = '#ff9d6f'
        this.colors.roughnessLow = '0.1'
        this.colors.roughnessHigh = '0.9'

        this.uniforms = {}
        this.uniforms.uPositionFrequency = new THREE.Uniform(0.8),
        this.uniforms.uStrength = new THREE.Uniform(0.01),
        this.uniforms.uColorLow = new THREE.Uniform(new THREE.Color(this.colors.colorA)),
        this.uniforms.uColorHigh = new THREE.Uniform(new THREE.Color(this.colors.colorB))
        
        this.material = new CustomShaderMaterial({
            // CustomShaderMaterial
            baseMaterial: THREE.MeshPhysicalMaterial,
            // vertexShader: moonAnimationRiggingVertexShader,
            // fragmentShader: moonAnimationRiggingFragmentShader,
            vertexShader: moonAnimationModelingVertexShader,
            fragmentShader: moonAnimationModelingFragmentShader,
            uniforms: this.uniforms,
            silent: true,
            
            //MeshPhysicalMaterial
            metalness: 0.0,
            roughness: 1.0,
            color: 0xffffff,
            emissive: 0x000000,
            transmission: 0.0,
            ior: 1.5,
            thickness: 1.5,
            transparent: false,
            wireframe: false,
            depthWrite: true,
            depthTest: true,
        })
    }

    setMesh(){
        this.mesh = new THREE.Mesh(
            this.geometry,
            this.material
        )
        this.mesh.castShadow = true
        this.mesh.receiveShadow = true
        this.scene.add(this.mesh)
    }
    
    setPosition(){
        this.orbitPlane = (Math.sin(this.planetTilt) * this.orbitDistance) / (Math.tan(this.planetTilt))
        this.orbitSpeed = 0.1
        this.offset = Math.PI * 0.6
    }
    
    rotate(){
        this.mesh.rotation.y = (this.time.elapsed * 0.001) * 0.25
    }

    orbit(){
        if(this.planetGroup){
            this.mesh.position.x = this.planetGroup.position.x + (this.orbitPlane * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
            this.mesh.position.z = this.planetGroup.position.z + (this.orbitDistance * Math.cos(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
            this.mesh.position.y = this.planetGroup.position.y + (this.orbitDistance * Math.sin(this.planetTilt) * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
        }
        else{
            console.log("no Planet Group")
        }
    }
}

export class MoonAnimationSimulation{
    constructor(parentPlanet){
        this.experience = new Experience()
        this.time = this.experience.time
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.parentPlanet = parentPlanet
        this.planetGroup = this.parentPlanet.planetGroup
        this.planetTilt = this.parentPlanet.planetTilt
        this.orbitDistance = this.parentPlanet.moonDOrbitDistance
        
        // Subscribe to the tick function
        this.time.addEventListener("tick", ()=>{
            this.rotate()
            this.orbit()
        })

        this.setGeometry()
        this.setTextures()
        this.setMaterials()
        this.setMesh()
        this.setPosition()
    }

    setGeometry(){
        let moonAnimationRiggingGeo = new THREE.IcosahedronGeometry(1.2, 25)
        this.geometry = mergeVertices(moonAnimationRiggingGeo)
        this.geometry.computeTangents()
    }
    setTextures(){
        
    }

    setMaterials(){
        this.colors = {}
        this.colors.colorA = '#3b5d38'
        this.colors.colorB = '#8cb1de'
        this.colors.roughnessLow = '0.1'
        this.colors.roughnessHigh = '0.9'

        this.uniforms = {}
        this.uniforms.uPositionFrequency = new THREE.Uniform(0.8),
        this.uniforms.uStrength = new THREE.Uniform(0.01),
        this.uniforms.uColorLow = new THREE.Uniform(new THREE.Color(this.colors.colorA)),
        this.uniforms.uColorHigh = new THREE.Uniform(new THREE.Color(this.colors.colorB))
        
        this.material = new CustomShaderMaterial({
            // CustomShaderMaterial
            baseMaterial: THREE.MeshPhysicalMaterial,
            // vertexShader: moonAnimationRiggingVertexShader,
            // fragmentShader: moonAnimationRiggingFragmentShader,
            vertexShader: moonAnimationModelingVertexShader,
            fragmentShader: moonAnimationModelingFragmentShader,
            uniforms: this.uniforms,
            silent: true,
            
            //MeshPhysicalMaterial
            metalness: 0.0,
            roughness: 1.0,
            color: 0xffffff,
            emissive: 0x000000,
            transmission: 0.0,
            ior: 1.5,
            thickness: 1.5,
            transparent: false,
            wireframe: false,
            depthWrite: true,
            depthTest: true,
        })
    }

    setMesh(){
        this.mesh = new THREE.Mesh(
            this.geometry,
            this.material
        )
        this.mesh.castShadow = true
        this.mesh.receiveShadow = true
        this.scene.add(this.mesh)
    }
    
    setPosition(){
        this.orbitPlane = (Math.sin(this.planetTilt) * this.orbitDistance) / (Math.tan(this.planetTilt))
        this.orbitSpeed = 0.01
        this.offset = Math.PI * 0.55
    }
    
    rotate(){
        this.mesh.rotation.y = (this.time.elapsed * 0.001) * 0.25
    }

    orbit(){
        if(this.planetGroup){
            this.mesh.position.x = this.planetGroup.position.x + (this.orbitPlane * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
            this.mesh.position.z = this.planetGroup.position.z + (this.orbitDistance * Math.cos(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
            this.mesh.position.y = this.planetGroup.position.y + (this.orbitDistance * Math.sin(this.planetTilt) * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
        }
        else{
            console.log("no Planet Group")
        }
    }
}